import { render, staticRenderFns } from "./vipCard.vue?vue&type=template&id=49a035a4&scoped=true"
import script from "./vipCard.vue?vue&type=script&lang=js"
export * from "./vipCard.vue?vue&type=script&lang=js"
import style0 from "./vipCard.vue?vue&type=style&index=0&id=49a035a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a035a4",
  null
  
)

export default component.exports